import IQAgiasInput       from '@/pages/giasInput/IQA'
import IQCgiasInput       from '@/pages/giasInput/IQC'
import giasStats       from '@/pages/giasInput/giasStats'
import gias2024Stats       from '@/pages/giasInput/gias2024Stats'
import giasEdit       from '@/pages/giasInput/giasEdit'
export default [
    {
        path: '/IQAgiasInput', 
        name: 'IQAgiasInput',
        component: IQAgiasInput,
    },
    {
        path: '/IQCgiasInput', 
        name: 'IQCgiasInput',
        component: IQCgiasInput,
    },
    {
        path: '/giasStats', 
        name: 'giasStats',
        component: giasStats,
    },
    {
        path: '/giasEdit', 
        name: 'giasEdit',
        component: giasEdit, 
    },
    {
        path: '/gias2024Stats', 
        name: 'gias2024Stats',
        component: gias2024Stats,
    }
]
